import router from './router';
import login from './login';
import clerkSync from './clerk-sync';

export default {
  ...router,
  ...login,
  clerkSync,
};
